import type { AppState } from '../../store/types';
import type { AnyObject, ObjectWithId } from '../../types/common';

const EMPTY_MODAL_OPTIONS: AnyObject = {};
const NO_CONTEXT_ITEMS: ObjectWithId[] = [];

export const getModalContextItems = (state: AppState, modalId: string) => {
  return state.modalsManager[modalId]?.contextItems;
};

export const selectOptions = (state: AppState, modalId: string) =>
  state.modalsManager[modalId]?.options ?? EMPTY_MODAL_OPTIONS;

/**
 * The modal store holds every modal's context items and options in one untyped
 * bag, while each modal knows the shapes it was opened with. These read them as
 * those shapes.
 */
export const selectModalContextItems = <Item extends ObjectWithId>(
  state: AppState,
  modalId: string,
): Item[] =>
  // biome-ignore lint/plugin: see above.
  (getModalContextItems(state, modalId) ?? NO_CONTEXT_ITEMS) as Item[];

/** See selectModalContextItems. */
export const selectModalOptions = <Options extends object>(
  state: AppState,
  modalId: string,
): Options =>
  // biome-ignore lint/plugin: see selectModalContextItems.
  selectOptions(state, modalId) as Options;
